import React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import { Checkbox, ErrorText, ExtendedTheme, Link } from 'neon-design-system';
import { config } from '../../config';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) =>
	createStyles({
		termsCheckbox: {
			'& label': {
				marginRight: 0
			},
			'& a': {
				lineHeight: `${theme.spacing(2.5)}px`,
				paddingTop: theme.spacing(0.25)
			}
		}
	})
);

interface TermsAndConditionsCheckboxProps {
	acceptedTerms: boolean;
	setAcceptedTerms: (acceptedTerms: boolean) => void;
	showError?: boolean;
}

export const TermsAndConditionsCheckbox = (props: TermsAndConditionsCheckboxProps) => {
	const classes = useStyles();
	const { acceptedTerms, setAcceptedTerms, showError } = props;

	return (
		<>
			<Box display="flex" alignItems="center" className={classes.termsCheckbox}>
				<Checkbox
					checked={acceptedTerms}
					value={acceptedTerms ? '1' : '0'}
					label="I agree to the Neon by Marex"
					onChange={(event: { target: { checked: boolean } }) => {
						setAcceptedTerms(event.target.checked);
					}}
				/>
				&nbsp;
				<Link ignoreRouter to={config.premiumContentPageUrl} target="_blank">Terms of Service for Premium Content</Link>
			</Box>
			{
				showError && (
					<Box mt={0.5}>
						<ErrorText>Terms of Service for Premium Content is required</ErrorText>
					</Box>
				)
			}
		</>
	);
}

export default TermsAndConditionsCheckbox;
